// @flow

import type { Action } from './store.type';
import { ThemesType } from 'src/models/theme-setup';

export const GET_ALL_THEMES_V3_REQUEST = 'GET_ALL_THEMES_V3_REQUEST';
type GET_ALL_THEMES_V3_REQUEST_TYPE = 'GET_ALL_THEMES_V3_REQUEST';

export const GET_ALL_THEMES_V3_SUCCESS = 'GET_ALL_THEMES_V3_SUCCESS';
type GET_ALL_THEMES_V3_SUCCESS_TYPE = 'GET_ALL_THEMES_V3_SUCCESS';

export const GET_ALL_THEMES_V3_FAILURE = 'GET_ALL_THEMES_V3_FAILURE';
type GET_ALL_THEMES_V3_FAILURE_TYPE = 'GET_ALL_THEMES_V3_FAILURE';

export const CHECK_THEME_V3_REQUEST = 'CHECK_THEME_V3_REQUEST';
type CHECK_THEME_V3_REQUEST_TYPE = 'CHECK_THEME_V3_REQUEST';

export const CHECK_THEME_V3_SUCCESS = 'CHECK_THEME_V3_SUCCESS';
type CHECK_THEME_V3_SUCCESS_TYPE = 'CHECK_THEME_V3_SUCCESS';

export const CHECK_THEME_V3_FAILURE = 'CHECK_THEME_V3_FAILURE';
type CHECK_THEME_V3_FAILURE_TYPE = 'CHECK_THEME_V3_FAILURE';

export const SETUP_THEME_V3_REQUEST = 'SETUP_THEME_V3_REQUEST';
type SETUP_THEME_V3_REQUEST_TYPE = 'SETUP_THEME_V3_REQUEST';

export const SETUP_THEME_V3_SUCCESS = 'SETUP_THEME_V3_SUCCESS';
type SETUP_THEME_V3_SUCCESS_TYPE = 'SETUP_THEME_V3_SUCCESS';

export const SETUP_THEME_V3_FAILURE = 'SETUP_THEME_V3_FAILURE';
type SETUP_THEME_V3_FAILURE_TYPE = 'SETUP_THEME_V3_FAILURE';

export const GET_THEMES_REQUEST = 'GET_THEMES_REQUEST';
type GET_THEMES_REQUEST_TYPE = 'GET_THEMES_REQUEST';

export const GET_THEMES_SUCCESS = 'GET_THEMES_SUCCESS';
type GET_THEMES_SUCCESS_TYPE = 'GET_THEMES_SUCCESS';

export const GET_THEMES_FAILURE = 'GET_THEMES_FAILURE';
type GET_THEMES_FAILURE_TYPE = 'GET_THEMES_FAILURE';

export const REVERT_THEME_V3_REQUEST = 'REVERT_THEME_V3_REQUEST';
type REVERT_THEME_V3_REQUEST_TYPE = 'REVERT_THEME_V3_REQUEST';

export const REVERT_THEME_V3_SUCCESS = 'REVERT_THEME_V3_SUCCESS';
type REVERT_THEME_V3_SUCCESS_TYPE = 'REVERT_THEME_V3_SUCCESS';

export const REVERT_THEME_V3_FAILURE = 'REVERT_THEME_V3_FAILURE';
type REVERT_THEME_V3_FAILURE_TYPE = 'REVERT_THEME_V3_FAILURE';

export const REMOVE_OLD_THEME_REQUEST = 'REMOVE_OLD_THEME_REQUEST';
type REMOVE_OLD_THEME_REQUEST_TYPE = 'REMOVE_OLD_THEME_REQUEST';

export const REMOVE_OLD_THEME_SUCCESS = 'REMOVE_OLD_THEME_SUCCESS';
type REMOVE_OLD_THEME_SUCCESS_TYPE = 'REMOVE_OLD_THEME_SUCCESS';

export const REMOVE_OLD_THEME_FAILURE = 'REMOVE_OLD_THEME_FAILURE';
type REMOVE_OLD_THEME_FAILURE_TYPE = 'REMOVE_OLD_THEME_FAILURE';

export const UPGRADE_THEME_V3_REQUEST = 'UPGRADE_THEME_V3_REQUEST';
type UPGRADE_THEME_V3_REQUEST_TYPE = 'UPGRADE_THEME_V3_REQUEST';

export const UPGRADE_THEME_V3_SUCCESS = 'UPGRADE_THEME_V3_SUCCESS';
type UPGRADE_THEME_V3_SUCCESS_TYPE = 'UPGRADE_THEME_V3_SUCCESS';

export const UPGRADE_THEME_V3_FAILURE = 'UPGRADE_THEME_V3_FAILURE';
type UPGRADE_THEME_V3_FAILURE_TYPE = 'UPGRADE_THEME_V3_FAILURE';

export const RESET_THEME_SETUP_V3 = 'RESET_THEME_SETUP_V3';
type RESET_THEME_SETUP_V3_TYPE = 'RESET_THEME_SETUP_V3';

export const GET_MAIN_THEME_SETUP_STATUS_REQUEST = 'GET_MAIN_THEME_SETUP_STATUS_REQUEST';
type GET_MAIN_THEME_SETUP_STATUS_REQUEST_TYPE = 'GET_MAIN_THEME_SETUP_STATUS_REQUEST';

export const GET_MAIN_THEME_SETUP_STATUS_SUCCESS = 'GET_MAIN_THEME_SETUP_STATUS_SUCCESS';
type GET_MAIN_THEME_SETUP_STATUS_SUCCESS_TYPE = 'GET_MAIN_THEME_SETUP_STATUS_SUCCESS';

export const GET_MAIN_THEME_SETUP_STATUS_FAILURE = 'GET_MAIN_THEME_SETUP_STATUS_FAILURE';
type GET_MAIN_THEME_SETUP_STATUS_FAILURE_TYPE = 'GET_MAIN_THEME_SETUP_STATUS_FAILURE';

type ThemeSetupV3Failure = {
  error: any
};

type GetAllThemesV3RequestAction = Action<GET_ALL_THEMES_V3_REQUEST_TYPE, null>;

type GetAllThemesV3SuccessAction = Action<GET_ALL_THEMES_V3_SUCCESS_TYPE, { data: ThemesType }>;

type GetAllThemesV3FailureAction = Action<GET_ALL_THEMES_V3_FAILURE_TYPE, ThemeSetupV3Failure>;

type CheckThemeV3RequestAction = Action<CHECK_THEME_V3_REQUEST_TYPE, null>;

type CheckThemeV3SuccessAction = Action<
  CHECK_THEME_V3_SUCCESS_TYPE,
  { data: { inputThemeName: string, outputThemeName: string } }
>;

type CheckThemeV3FailureAction = Action<CHECK_THEME_V3_FAILURE_TYPE, ThemeSetupV3Failure>;

type SetupThemeV3RequestAction = Action<SETUP_THEME_V3_REQUEST_TYPE, null>;

type SetupThemeV3SuccessAction = Action<SETUP_THEME_V3_SUCCESS_TYPE, { data: { message: string } }>;

type SetupThemeV3FailureAction = Action<SETUP_THEME_V3_FAILURE_TYPE, ThemeSetupV3Failure>;

type GetThemesRequestAction = Action<GET_THEMES_REQUEST_TYPE, null>;

type GetThemesSuccessAction = Action<GET_THEMES_SUCCESS_TYPE, { data: ThemesType }>;

type GetThemesFailureAction = Action<GET_THEMES_FAILURE_TYPE, ThemeSetupFailure>;

type RevertThemeV3RequestAction = Action<REVERT_THEME_V3_REQUEST_TYPE, null>;

type RevertThemeV3SuccessAction = Action<
  REVERT_THEME_V3_SUCCESS_TYPE,
  { data: { message: string } }
>;

type RevertThemeV3FailureAction = Action<REVERT_THEME_V3_FAILURE_TYPE, ThemeRevertFailure>;

type RemoveOldThemeRequestAction = Action<REMOVE_OLD_THEME_REQUEST_TYPE, null>;

type RemoveOldThemeSuccessAction = Action<
  REMOVE_OLD_THEME_SUCCESS_TYPE,
  { data: { message: string } }
>;

type RemoveOldThemeFailureAction = Action<REMOVE_OLD_THEME_FAILURE_TYPE, ThemeRevertFailure>;

type UpgradeThemeV3RequestAction = Action<UPGRADE_THEME_V3_REQUEST_TYPE, null>;

type UpgradeThemeV3SuccessAction = Action<
  UPGRADE_THEME_V3_SUCCESS_TYPE,
  { data: { message: string } }
>;

type UpgradeThemeV3FailureAction = Action<UPGRADE_THEME_V3_FAILURE_TYPE, ThemeRevertFailure>;

type ResetThemeSetupV3 = Action<RESET_THEME_SETUP_V3_TYPE>;

type GetMainThemeSetupStatusRequestAction = Action<GET_MAIN_THEME_SETUP_STATUS_REQUEST_TYPE, null>;

type GetMainThemeSetupStatusSuccessAction = Action<
  GET_MAIN_THEME_SETUP_STATUS_SUCCESS_TYPE,
  { data: { status: string } }
>;

type GetMainThemeSetupStatusFailureAction = Action<
  GET_MAIN_THEME_SETUP_STATUS_FAILURE_TYPE,
  ThemeSetupFailure
>;

export type ThemeSetupV3Action =
  | GetAllThemesV3RequestAction
  | GetAllThemesV3SuccessAction
  | GetAllThemesV3FailureAction
  | CheckThemeV3RequestAction
  | CheckThemeV3SuccessAction
  | CheckThemeV3FailureAction
  | SetupThemeV3RequestAction
  | SetupThemeV3SuccessAction
  | SetupThemeV3FailureAction
  | GetThemesRequestAction
  | GetThemesSuccessAction
  | GetThemesFailureAction
  | RevertThemeV3RequestAction
  | RevertThemeV3SuccessAction
  | RevertThemeV3FailureAction
  | RemoveOldThemeRequestAction
  | RemoveOldThemeSuccessAction
  | RemoveOldThemeFailureAction
  | UpgradeThemeV3RequestAction
  | UpgradeThemeV3SuccessAction
  | UpgradeThemeV3FailureAction
  | ResetThemeSetupV3
  | ClearRevertThemeV3ShowModal
  | GetMainThemeSetupStatusRequestAction
  | GetMainThemeSetupStatusSuccessAction
  | GetMainThemeSetupStatusFailureAction;

export type ThemeSetupV3State = {
  getThemesLoading: boolean,
  getAllThemesLoading: boolean,
  checkThemeLoading: boolean,
  installThemeLoading: boolean,
  integrateGemPagesLoading: boolean,
  upgradeThemeLoading: boolean,
  getThemesSuccess: boolean,
  getAllThemesSuccess: boolean,
  checkThemeSuccess: boolean,
  installThemeSuccess: boolean,
  submitErrorSuccess: boolean,
  integrateGemPagesSuccess: boolean,
  upgradeThemeSuccess: boolean,
  error: any,
  setupThemeError: any,
  themes: ThemesType | [],
  allThemes: ThemesType | [],
  isTrialTheme: boolean,
  inputThemeName: string,
  outputThemeName: string,
  isOS20: boolean,
  integrateGemPagesThemes: Object,
  mainThemeSetupStatus: string
};
